import { getUserToken,getUserInfo,dictionaryList,dictionaryObj,constantList,userRelated,userAuth } from '@/api/login'
import { getToken, setToken, removeToken, removeCookie } from '@/utils/auth'
import { jumpClient,jumpPassport,jumpHome } from '@/utils/url_redirection'
import axios from 'axios'
import { resetRouter } from '@/router'
import {generateRedirect} from '@/utils/skip'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',//用户名称
    avatar: '',//头像
    userType:'',//用户类型  1 采购蓝色 2供应 绿色 3工厂青色
    userInfo:'',//用户信息
    constantList:{},//常量
    generalData:{},//用户通用数据
    isLogin:false,//是否登录

    dictionary:'',//字典 缓存
    dictionaryObj:'',//字典对象集合

  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {//重置 VUEX
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {//设置token
    state.token = token
  },
  SET_NAME: (state, name) => {//设置名称
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {//设置头像
    state.avatar = avatar
  },
  SET_USERINFO:(state,userInfo)=>{//设置用户信息
    state.userInfo = userInfo
  },
  SET_CONSTANT: (state, data) => {//设置常量
    state.constantList = data
  },
  SET_USERTYPE:(state,userType)=>{//设置用户类型
    state.userType = userType
  },
  SET_ISLOGIN:(state,isLogin)=>{//设置是否登录
    state.isLogin = isLogin
  },
  SET_DICTIONARY:(state,data)=>{//缓存字典
    state.dictionary = data
  },
  SET_DICTIONARYOBJ:(state,data)=>{//缓存字典对象集合
    state.dictionaryObj = data
  },
   SET_GENERALDATA:(state,generalData)=>{//设置用户通用数据
    state.generalData = generalData
  },
}

const actions = {
  set_generalData({commit},data){//设置用户通用数据
        commit('SET_GENERALDATA', data)
    },
  set_userType({commit},data){//设置用户类型
    commit('SET_USERTYPE', data)
  },
  // user login
  login({ commit }, code) {
    return new Promise((resolve, reject) => {
        getUserToken(code).then(response => {
            const { data } = response
            commit('SET_TOKEN', data)
            setToken(data)
            resolve()
        }).catch(error => {
            reject(error)
        })
    })
  },
  getInfo({ commit, state, dispatch }) { // get user info
    return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
            const { data } = response
            if (!data) {
                return reject('验证失败，请重新登录!')
            }
            commit('SET_USERINFO',data)
            commit('SET_NAME', data.nickName)
            commit('SET_AVATAR', data.faceUrl)
            commit('SET_USERTYPE',data.customerType)
            commit('SET_ISLOGIN',true)
            // userRelated({}).then(res =>{
            //   commit('SET_AVATAR', res.data.faceUrl)
            //   commit('SET_GENERALDATA', res.data)
            // })
            userAuth().then(res=>{
              commit('SET_GENERALDATA', res.data)
              console.log(JSON.parse(JSON.stringify(res.data)),'授权信息')
            })
            resolve();
        }).catch(error => {
            location.href = '/'
            reject(error)
        })


    })
  },
  get_constantList({ commit, state }){//获取常量
    return new Promise((resolve, reject) => {
      constantList().then(res=>{
        commit('SET_CONSTANT',res.data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  get_correlation({ commit, state }){
     return Promise.all([
      dictionaryList().then(res=>{
        commit('SET_DICTIONARY',res.data)
        return res.data
      }),
      dictionaryObj().then(res=>{
        commit('SET_DICTIONARYOBJ',res.data)
        return res.data
      })
    ])
  },
  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
        let newData = {
            clientId:'zhuzaobao',
            //redirectUri:`${jumpHome()}/index`,
            redirectUri:`${jumpHome()}`,
            username:state.userInfo.username,
        }
        var url = `${process.env.VUE_APP_BASE_API}/logout/exit`
        if(url.indexOf('testuser')>-1){
            url = url.replaceAll('testuser','testsso')
            if(url.indexOf('user')>-1){
                url = url.replaceAll('user','passport')
            }
        }else if(url.indexOf('user')>-1){
            url = url.replaceAll('user','passport')
        }else if(url.indexOf('8090')>-1){
            url = url.replaceAll('8090','9000')
        }else if(url.indexOf('8099')>-1){
            url = url.replaceAll('8099','9009')
        }
        axios({
            //url: `https://passport.zhuzaobao.com/passport/logout/exit`,
            url: url,
            method:'get',
            params: newData,
            headers: {'Authorization' : "Bear "+ getToken()}
        }).then(response => {
            removeToken() // must remove  token  first
            removeCookie('zhuzaobao-client-token')
            removeCookie('vue_admin_user_token')
            removeCookie('SSO_SESSION')
            resetRouter()
            commit('RESET_STATE')
            

            //location.href = generateRedirect('/login','/')
            // let protocol = window.location.protocol; // 例如 "http:" 或 "https:"
            // let host = window.location.host; // 例如 "www.example.com"
            // let pathname = window.location.pathname; // 例如 "/path/to/page"
            // let search = window.location.search; // 查询字符串，例如 "?param=value"
            // let hash = window.location.hash; // 哈希值，例如 "#section1"
            // console.log('protocol',protocol)
            // console.log('host',host)
            // console.log('pathname',pathname)
            // console.log('search',search)
            // console.log('hash',hash)

            // let fullPath = `${protocol}//${host}${pathname}${search}${hash}`
            // console.log('fullPath',fullPath)
            // alert('退出成功:' + fullPath)
            // window.location.href = fullPath
             let fullPath = window.location.toString();
            // alert('退出成功:' + fullPath)
            window.location.href = fullPath

            resolve()
        }).catch(error => {
            location.href = '/'
            reject(error)
            console.error(error)
        })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

